import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import LoadCSSforfirstTime from "../../../../CloudStorage/LoadCSSforfirstTime";
import CloudStorage from "../../../../CloudStorage/CloudStorage";
import { useSelector } from "react-redux";
import { formatNumberWithCommas, getTime } from "../../../Common/AllDateTimeReleventFormate";
import CustomReactQuillDescription from "../../../Common/CustomeLabel/ReactQuill/CustomReactQuillDescription";
import ProfilePic from "../../../../assests/imgs/Profileplaceholder.svg";
import ImageWithFallback from "../../../../common/ImageWithFallback";
import WorkingDayComponent from "../../../Common/WorkingDayComponent";
import WorkingHourComponent from "../../../Common/WorkingHourComponent";
import SubcategoryComponent from "../../../Common/SubcategoryComponent";
import StarRatingComponent from "../../../Common/StarRatingComponent";
import DisplayFileProper from "../../../Common/FilesRelevent/DisplayFileProper";
import YearRange from "../../../Common/YearRange";

export default function PublicPreviewEP() {
  const path = "Assets/scss/hireexpert.module.scss";
  useEffect(() => {
    LoadCSSforfirstTime(path);
  }, [path]);

  const laung = localStorage.getItem("laung");
  const [lan, setlan] = useState(laung ?? "en");
  const navigate = useNavigate();
  const formData = useSelector(({ profile: { profiledata } }) => profiledata);
  const edittype = 1;

  return (
    <div className="hire-details col-lg-10 mx-auto manage-profile p-0 col-md-11">
      <p className="breadcrumbs">
        <a onClick={() => navigate(`/${lan}/dashboard`)}>Dashboard &gt; </a>
        {formData?.role_type == 1 || formData?.role_type == 2 ? (
          ""
        ) : (
          <a onClick={() => navigate(`/${lan}/dashboard/manageprofile`)}>
            Manage profile &gt;
          </a>
        )}
        Public Preview
      </p>
      <div className="expertdetail-first">
        <div className="expertdetail-row">
          <div className="expert-left">
            <img src={formData?.profile_image ? formData?.profile_image : ProfilePic} alt="" />
            <div>
              <h2 className="manage-head">
                {formData?.first_name} {formData?.last_name}
              </h2>
              <h6>
                {formData?.expert ? formData?.expert?.designation : ""}
                {formData?.company ? formData?.company?.cr_number : ""}
                <span>
                  <img
                    src={`${CloudStorage.cloudurl}/Assets/Images/hireexpert/map-icon.svg`}
                    alt=""
                  />
                  {formData?.country_title}
                </span>
              </h6>
            </div>
          </div>
        </div>
      </div>
      <div className="expertdetail-second col-md-12">
        <div className="row">
          <div className="col-lg-3 col-md-4 expert-second-left d-flex flex-column " style={{rowGap:'10px'}}>
            {/* <p className="about-me">
              {formData?.company || formData?.iam == 2
                ? "About Company"
                : "About Expert"}
            </p> */}
            <div className="about-expert">
              <h6>
                Industry, Category & Subcategory
              </h6>
              <p>
                <h6>Industry : </h6>
                {formData?.industries?.map((item, index) => (
                  <>
                    <p key={index}>{item?.title}</p>
                  </>
                ))}
              </p>
              <p>
                <h6>Category : </h6>
                {formData?.categories?.map((item, index) => (
                  <>
                    <p key={index}>{item?.title}</p>
                  </>
                ))}
              </p>
              <p>
                <h6>Subcategory : </h6>
                <SubcategoryComponent formData={formData} />
              </p>
            </div>

            {(formData?.company || formData?.iam == 2) && (
              <>
                {formData?.iam == 1 ? (
                  ""
                ) : (
                  <div className="about-expert">
                    <h6>
                      Job preferences
                    </h6>
                    <p>
                      $
                      {formData?.company
                        ? formData?.company?.price_per_hour == ""
                          ? formData?.price_per_hour
                          : formData?.company?.price_per_hour
                        : formData?.price_per_hour}
                      /hour
                    </p>
                    <p>
                      $
                      {formData?.company
                        ? formData?.company?.price_per_month == ""
                          ? formData?.price_per_month
                          : formData?.company?.price_per_month
                        : formData?.price_per_month}
                      /month
                    </p>
                  </div>
                )}
              </>
            )}

            <div className="about-expert">
              <h6>language</h6>
              {Array.isArray(formData?.language) &&
                formData?.language?.map((item, index) => (
                  <p key={index} style={{ color: '#686868' }}>
                    {item?.language_title} - {item?.proficiency_title}
                  </p>
                ))}
            </div>
            {(formData?.expert || formData?.iam == 1) && (
              <div className="about-expert">
                <h6>Academic info</h6>
                {Array.isArray(formData?.education) &&
                  formData?.education?.map((item, index) => (
                    <React.Fragment key={index}>
                      <p>
                        {item?.field} - {item?.university}
                      </p>
                      <p>
                        {item?.from_year} - {item?.to_year}
                      </p>
                    </React.Fragment>
                  ))}
              </div>
            )}
            {(formData?.expert || formData?.iam == 1) && (
              <div className="about-expert">
                <h6>Employment </h6>
                {Array.isArray(formData?.experience) &&
                  formData?.experience?.map((item, index) => (
                    <React.Fragment key={index}>
                      <p>
                        {item?.designation} - {item?.company}
                      </p>
                      <YearRange fromYear={item?.from_year} toYear={item?.to_year} />
                    </React.Fragment>
                  ))}
              </div>
            )}
            {formData?.expert && (
              <div className="about-expert">
                <h6>Charges </h6>
                <p>
                  $
                  {formData?.expert
                    ? formData?.expert?.price_per_hour
                    : formData?.price_per_hour}
                  /hour
                </p>
                <p>
                  $
                  {formData?.expert
                    ? formData?.expert?.price_per_month
                    : formData?.price_per_month}
                  /month
                </p>
              </div>
            )}
            {formData?.company && (
              <div className="about-expert">
                <h6>Charges </h6>
                <p>
                  $
                  {formData?.company
                    ? formData?.company?.price_per_hour
                    : formData?.price_per_hour}
                  /hour
                </p>
                <p>
                  $
                  {formData?.company
                    ? formData?.company?.price_per_month
                    : formData?.price_per_month}
                  /month
                </p>
              </div>
            )}
            {formData?.preferences?.working_days && formData?.preferences?.working_days?.length &&
              <div className="about-expert">
                <h6>
                  Working Days
                </h6>
                <WorkingDayComponent formData={formData} />
              </div>
            }
            {Array.isArray(formData?.working_hours) && formData?.working_hours?.length > 0 &&
              <div className="about-expert">
                <h6> Working Hour  </h6>
                <WorkingHourComponent formData={formData} />
              </div>
            }
          </div>
          <div className="col-lg-9 col-md-8 expert-second-right">
            {formData?.expert && (
              <>
                <h4>Designation</h4>
                <h4 className="d-flex justify-content-between align-items-center">
                  {formData?.expert
                    ? formData?.expert?.designation
                    : formData?.designation}
                </h4>
                <CustomReactQuillDescription value={formData?.expert ? formData?.expert?.about : formData?.about} />
              </>
            )}
            {edittype == 2 && formData?.iam == 1 && (
              <>
                <h4 className="d-flex justify-content-between align-items-center">
                  About Expert
                </h4>
                <h4>Designation</h4>
                <h4>
                  {formData?.expert
                    ? formData?.expert?.designation
                    : formData?.designation}
                </h4>
                <p>
                  <CustomReactQuillDescription value={formData?.expert ? formData?.expert?.about : formData?.about} />
                </p>
              </>
            )}
            {(formData?.company || formData?.iam == 2) && (
              <>
                <h4 className="d-flex justify-content-between align-items-center">
                  About company
                </h4>
                <p>
                  <CustomReactQuillDescription value={formData?.company ? formData?.company?.about : formData?.about} />
                </p>
              </>
            )}

            {(formData?.company || formData?.iam == 2) && (
              <div className="expert-sub-sec">
                <div className="expert-heading">
                  <h6>Industries </h6>
                </div>
                <div className="skills">
                  {Array.isArray(formData?.industries) &&
                    formData?.industries?.map((item, index) => (
                      <p key={index}>{item?.title}</p>
                    ))}
                </div>
              </div>
            )}

            <div className="expert-sub-sec">
              <div className="expert-heading">
                <h6>Competencies </h6>
              </div>
              <div className="skills">
                {Array.isArray(formData?.skills) &&
                  formData?.skills?.map((item, index) => <p key={index}>{item?.title}</p>)}
              </div>
            </div>
            {Array.isArray(formData?.work_sample) &&
              formData?.work_sample?.length > 0 && (
                <div className="expert-sub-sec">
                  <div className="expert-heading">
                    <h6>Work samples</h6>
                    {edittype == 1 && (
                      <button
                        className="btn"
                        onClick={() =>
                          navigate(`/${lan}/dashboard/manageportfolio`)
                        }
                      >
                        View all
                      </button>
                    )}
                  </div>
                  <div className="row exp-row">
                    {Array.isArray(formData?.work_sample) &&
                      formData?.work_sample?.map((item, index) => (
                        <div key={index} className="col-lg-4 col-md-6  expert-img" onClick={() => navigate(`/${lan}/worksample/${item.id}`)}>
                          <DisplayFileProper item={{ file: (Array.isArray(item?.files) && item?.files[0]?.file) }} className="w-100" />
                          <h5>{item?.title}</h5>
                        </div>
                      ))}
                  </div>
                </div>
              )}
            {Array.isArray(formData?.bxp) && formData?.bxp?.length > 0 && (
              <div className="expert-sub-sec">
                <div className="expert-heading">
                  <h6>One time service (OTS)</h6>
                  {edittype == 1 && (
                    <button
                      className="btn"
                      onClick={() =>
                        navigate(`/${lan}/dashboard/myotsproducts`)
                      }
                    >
                      View all
                    </button>
                  )}
                </div>
                <div className="row exp-row">
                  {Array.isArray(formData?.bxp) &&
                    formData?.bxp?.map((item, index) => (
                      <div key={index} className="col-lg-4 col-md-6  expert-img" onClick={() => { navigate(`/${lan}/packageddetails/${item.id}`); }}>
                        <DisplayFileProper item={{ file: (Array.isArray(item?.files) && item?.files[0]?.file) }} className="w-100" />
                        <h5>{item?.title}</h5>
                        <CustomReactQuillDescription
                          value={item?.description}
                        />
                        <h5>$ {formatNumberWithCommas(item?.price)}</h5>
                      </div>
                    ))}
                </div>
              </div>
            )}

            {edittype == 1 && (
              <>
                <div className="rating-sec">
                  <h2>Rating and Reviews </h2>
                  <div className="overall-rating">
                    <div className="earn-head">
                      <h2>Average rating</h2>
                      <div className="star">
                        <p>
                          <i className="fa-solid fa-star"></i>
                          <span>{formData?.avg_rating}</span>{" "}
                          ({formData?.comment_count}) reviews
                        </p>
                      </div>
                    </div>
                    <div className="review-right">
                      {formData.rating_category &&
                        formData.rating_category.map((rat_cat, indi) => {
                          return (
                            <div className="review-star" key={indi}>
                              <p>{rat_cat.title}</p>
                              <StarRatingComponent rat_cat={rat_cat} />
                            </div>
                          );
                        })}
                    </div>
                  </div>

                  {formData.ratings &&
                    formData.ratings.map((rating, indi) => {
                      return (
                        <div className="rating-detail" key={indi}>
                          <p>{rating.comment}</p>
                          <h5>
                            {rating.first_name} {rating.last_name}
                          </h5>
                        </div>
                      );
                    })}
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
